var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotakMahindraBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 6.30041 5.37234 1.6792 12.0002 1.6792C18.6281 1.6792 24 6.30041 24 12C24 17.6996 18.6277 22.3209 12.0002 22.3209C5.3728 22.3209 0 17.7003 0 12Z",
    fill: "#003874"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5432 4.99369L13.3312 4.07251L13.3449 19.1439L10.5333 20.0859L10.5432 4.99369Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0247 13.039C20.7631 15.1949 19.5538 17.373 16.9131 17.3771C15.3715 17.3799 14.1672 16.3243 13.3333 15.0329V13.537C14.3769 14.0552 15.3523 14.6113 16.5358 14.6282C17.9936 14.6497 19.3119 14.0893 19.857 13.0388H21.0249L21.0247 13.039ZM12.1974 14.3927C10.986 15.8529 9.81541 17.3444 7.62198 17.3444C4.52385 17.3444 3.05432 14.349 3.05432 11.8448C3.05432 9.43852 4.20276 6.59009 7.22101 6.59009C8.53011 6.59009 9.79023 7.39065 10.5414 8.23745L10.5391 10.2801C9.91153 9.85757 8.50585 9.4431 7.58811 9.42822C5.67412 9.39618 3.98671 10.2258 4.01601 12.1151C4.03592 13.4157 5.32465 14.2998 6.60674 14.2998C8.57039 14.2998 9.76002 12.506 10.7542 11.1445C11.1528 10.6247 11.5468 10.1015 11.9363 9.57493C13.0406 8.03193 14.3183 6.62327 16.5117 6.62327C19.0956 6.62327 20.5461 8.70593 20.9563 10.8499H19.789C19.3199 10.1546 18.4175 9.72918 17.5286 9.72918C15.4985 9.72918 14.2856 11.5967 13.2703 12.9717L12.1947 14.3925",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotakMahindraBank);
export default __webpack_public_path__ + "static/media/KotakMahindraBank.68fe52653a175e92d676bd5d8bc527d7.svg";
export { ForwardRef as ReactComponent };